export default "__VITE_ASSET__ZjF3LF0H__";